import { Navigate, Route, Routes } from 'react-router-dom-v5-compat'
import { CASHFLOW_REPORTING } from '@npco/component-mp-feature-cashflow-reporting-page'

import { CashflowReporting } from '../CashflowReporting/CashflowReporting'

export const ReportsRoutes = () => {
  return (
    <Routes>
      <Route
        index
        element={<Navigate to={CASHFLOW_REPORTING.path} replace />}
      />
      <Route
        path={CASHFLOW_REPORTING.relative}
        element={<CashflowReporting />}
      />
    </Routes>
  )
}
